const VISIBLE_ROWS_COUNT: number = 10;

export { VISIBLE_ROWS_COUNT };
